import type { Title } from "@/mocks/titles";
import TitleCard from "@/components/feature/TitleCard";

interface FeaturedGridProps {
  items: Title[];
}

export default function FeaturedGrid({ items }: FeaturedGridProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
      {items.map((item) => (
        <TitleCard key={item.id} title={item} />
      ))}
    </div>
  );
}